var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-2xl font-bold mb-1"},[_vm._v("\n    "+_vm._s(_vm.product.label)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }